/**
 * Fixed option sets for contact form dropdowns (small, stable, not tenant-customizable).
 * Single source of truth for labels and values; change here to update everywhere.
 */

/** Hearing status: value stored in DB, label shown in UI */
export const HEARING_STATUS_OPTIONS = [
  { value: 'hearing', label: 'Hearing' },
  { value: 'deaf_hard_of_hearing', label: 'Deaf/Hard of hearing' },
];

/** Interpretation status: value stored in DB, label shown in UI */
export const INTERPRETATION_STATUS_OPTIONS = [
  { value: 'not_needed', label: 'Not needed' },
  { value: 'asl', label: 'American Sign Language' },
  { value: 'foreign_language_preferred', label: 'Foreign Language (see Preferred Language)' },
];
